module.exports = __webpack_public_path__ + "static/media/wheelchair.c66e41ab.svg";